export const experienceData = [
  {
    id: 0,
    role: "Business Head IT & ITES - (Fractional)",
    company: "ERAM Digital (ERAM Holdings)",
    duration: "February 2026 - January 2031",
    location: "Al Khobar, Saudi Arabia",
    description: "Consultant leading strategic planning, business development, and operational management. Responsible for developing Business Plans, Feasibility Studies, Cash Flow Models, and Budgets. Building and managing teams, developing sales pipelines, managing P&L, and achieving financial targets. Ensuring operational compliance with industry regulations, data protection, and security standards.",
    website: "www.eramholdings.com"
  },
  {
    id: 1,
    role: "Chief Executive Officer",
    company: "ITHR Technologies Consulting LLC",
    duration: "August 2024 - Present",
    location: "Dubai, UAE",
    description: "Leading the company in developing human capital strategies, driving business growth, and ensuring operational excellence while enhancing client relations."
  },
  {
    id: 2,
    role: "Strategic Advisor - Founding Member - COO",
    company: "ITHR 360\u00b0 CONSULTING",
    duration: "March 2024 - Present",
    location: "Dubai, UAE",
    description: "Strategic advisory and operational leadership as a founding member, shaping company direction and growth strategies."
  },
  {
    id: 3,
    role: "Director - Operations",
    company: "Logic Point Information Technology Consultants",
    duration: "July 2019 - February 2024",
    location: "Dubai, UAE",
    description: "Operational management and leadership within the IT consulting sector, driving efficiency and client satisfaction."
  },
  {
    id: 4,
    role: "Executive Director",
    company: "Skillsearch Resources Private Limited",
    duration: "June 2011 - June 2019",
    location: "India",
    description: "Leadership and executive-level management, building and scaling recruitment operations."
  },
  {
    id: 5,
    role: "Executive Director",
    company: "Candid Consultants Private Limited",
    duration: "January 2004 - June 2011",
    location: "India",
    description: "Executive-level leadership driving business development and operational excellence."
  },
  {
    id: 6,
    role: "Executive",
    company: "Wipro Spectramind",
    duration: "2002 - 2004",
    location: "Mumbai, India",
    description: "Executive-level contributions within a large IT services company."
  }
];
